import React from 'react'
import { connect } from 'react-redux'
import { UserVehicleLink } from '../userVehicleLinkHOC'
import CardWrapper from './CardWrapper'

const ProductPackage = ({ vehicleInfo, internalUrl }) => {
  return (
    <CardWrapper
      leftText={`ID ${`${vehicleInfo.id}`}`}
      pillText={vehicleInfo.status && vehicleInfo.status.toUpperCase()}
      internalUrl={internalUrl}
      children=""
    />
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserVehicleLink(ProductPackage))
